import { produce } from 'immer'
import React from 'react'
import * as R from 'remeda'

import { useAtomContext, useAtomValueContext } from '../providers/AtomsProvider'

import { useGroupedQuestions } from './useGroupedQuestions'

export const useOmitNonTabulatedQuestionsDiffs = () => {
  const isTabulated = useAtomValueContext('isTabulated')
  const [questionsDiffsMap, setQuestionsDiffsMap] =
    useAtomContext('questionsDiffsMap')
  const [_normalQuestions, matrixQuestions] = useGroupedQuestions()

  React.useEffect(() => {
    if (!isTabulated) {
      return
    }

    const notTabulatedQuestionIds = R.pipe(
      questionsDiffsMap,
      R.keys(),
      R.differenceWith(
        matrixQuestions,
        (questionId, matrixQuestion) =>
          questionId === matrixQuestion.question_id,
      ),
    )
    if (0 < notTabulatedQuestionIds.length) {
      setQuestionsDiffsMap(
        produce((draft) => {
          notTabulatedQuestionIds.forEach((questionId) => {
            delete draft[questionId]
          })
        }),
      )
    }
  }, [isTabulated, matrixQuestions, questionsDiffsMap, setQuestionsDiffsMap])
}
